<script setup lang="ts">
import { storeToRefs } from 'pinia'
import type { ComputedRef } from 'vue'
import { useCategoriaStore } from './store/useCategoriaStore'
import type { ICategoria } from './types'
import type { IHeader, ITableAction } from '@/pages/types/layoutTable.types'
import type { ITerm } from '@/components/CDF/SearchBar.vue'
import LayoutTable from '@/components/CDF/LayoutTable.vue'

definePage({
  meta: {
    action: 'list',
    subject: 'categoria-fornecedor',
  },
})

const store = useCategoriaStore()
const router = useRouter()

const {
  items,
  itemsPerPage,
  page,
  loading,
  searchTerm,
  isSearching,
  categoriaParent,
} = storeToRefs(store)

const {
  loadMore,
  search: onSearch,
  searchAgain: onSearchAgain,
  resetSearch,
  destroy,
  dialogDestroy,
  onOrderBy,
} = store

const headers: ComputedRef<IHeader[]> = computed(() => {
  return [
    {
      title: 'Icone',
      key: 'icon',
      sortable: false,
    },
    {
      title: 'Descrição',
      key: 'descricao',
    },
  ]
})

const terms: ComputedRef<ITerm[]> = computed(() => {
  return [
    {
      title: 'Descrição',
      value: 'descricao',
    },
  ]
})

const actions: ITableAction[] = [
  /*
  {
    icon: 'tabler-eye',
    color: 'secondary',
    can: {
      action: 'list',
      subject: 'categoria',
    },
    onClick: (item: ICategoria) => {
      resetSearch()
      router.push(`/admin/categoria-fornecedor/${item.id}/listar`)
    },
  },
  */
  {
    icon: 'tabler-edit',
    color: 'primary',
    can: {
      action: 'edit',
      subject: 'categoria-fornecedor',
    },
    to: (item: ICategoria) => `/admin/categoria-fornecedor/editar/${item.id}`,
  },
  {
    icon: 'tabler-trash',
    color: 'error',
    can: {
      action: 'delete',
      subject: 'categoria-fornecedor',
    },
    onClick: (item: ICategoria) => dialogDestroy(item.id),
  },
]

onBeforeRouteLeave(() => {
  store.$reset()
  resetSearch()
})
</script>

<template>
  <LayoutTable
    v-model:items="items"
    v-model:loading="loading.items"
    v-model:loading-destroy="loading.destroy"
    v-model:search="searchTerm"
    v-model:is-searching="isSearching"
    :destroy="destroy"
    :title="`${categoriaParent ? `Categoria: ${categoriaParent.nome}` : $t('categoria.list')}`"

    :new-item="`${categoriaParent ? `/admin/categoria-fornecedor/${categoriaParent.id}/cadastrar/` : '/admin/categoria-fornecedor/cadastrar'}`"
    :headers="headers"
    :actions="actions"
    :items-per-page="itemsPerPage"
    :page="page"

    :load-more="loadMore"
    :terms-search="terms"
    :on-search="onSearch"
    :on-search-again="onSearchAgain"
    :on-reset="resetSearch"
    :on-order-by="onOrderBy"
    :fetch-params="{ categoria: router.currentRoute.value.params.id }"
  >
    <template #item.icon="{ item }">
      <VIcon
        color="primary"
        size="30"
        :icon="item?.icon_formatted"
      />
    </template>
  </LayoutTable>
</template>
